export const BrowserDate = Date;
